import { Box, ButtonBase, Typography, alpha, useTheme } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { brandNavItems } from '../../config'

/** Compact horizontal board chips — prefer SocrNavDrawer; kept for optional use. */
const BoardSwitcher = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  return (
    <Box
      role='navigation'
      aria-label='SOCR boards'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        gap: 0.25
      }}
    >
      {brandNavItems.map((board) => {
        const active =
          board.path === '/'
            ? pathname === '/' || pathname === ''
            : pathname === board.path || pathname.startsWith(`${board.path}/`)
        const accent =
          board.id === 'vulnerabilities'
            ? theme.custom.colors.supportTypes.vulnerability
            : theme.custom.keysys.blue

        return (
          <ButtonBase
            key={board.id}
            onClick={() => {
              if (!active) navigate(board.path)
            }}
            aria-current={active ? 'page' : undefined}
            aria-label={board.label}
            title={board.label}
            sx={{
              height: 34,
              px: { xs: 1, sm: 1.15 },
              borderRadius: 1,
              color: active ? alpha('#fff', 0.98) : alpha('#fff', 0.55),
              bgcolor: active ? alpha(accent, 0.22) : 'transparent',
              '&:hover': {
                color: alpha('#fff', 0.95),
                bgcolor: active ? alpha(accent, 0.28) : alpha('#fff', 0.06)
              }
            }}
          >
            <Typography
              component='span'
              sx={{
                fontWeight: 800,
                fontSize: { xs: '0.72rem', sm: '0.78rem' },
                lineHeight: 1,
                whiteSpace: 'nowrap'
              }}
            >
              {board.label}
            </Typography>
          </ButtonBase>
        )
      })}
    </Box>
  )
}

const formatRelativeTime = (ts) => {
  if (typeof ts !== 'number') return null
  const delta = Date.now() - ts
  if (delta < 60_000) return 'just now'
  if (delta < 3_600_000) return `${Math.floor(delta / 60_000)}m ago`
  if (delta < 86_400_000) return `${Math.floor(delta / 3_600_000)}h ago`
  return new Date(ts).toLocaleString()
}

export { BoardSwitcher, formatRelativeTime }
export { BoardSwitcher as PageNavSwitcher }
